import {YelpConfiguration} from '/src/com/yext/listingslaunchstorm/js/enterprise/setuppublisher/data/yelpconfiguration';
import {YelpSyncedFields} from '/src/com/yext/listingslaunchstorm/js/enterprise/setuppublisher/yelp/yelpsyncedfields';
import {EnterpriseConfiguration} from '/src/com/yext/listingslaunchstorm/js/enterprise/taskflow/data/enterpriseconfiguration';
import {Task} from '/src/com/yext/listingslaunchstorm/js/enterprise/taskflow/data/task';
import {TaskIds} from '/src/com/yext/listingslaunchstorm/js/enterprise/taskflow/data/taskids';

import YelpLogoLargeSvg from '/src/com/yext/listingslaunchstorm/public/icons/yelp-logo-large.svg';
import YelpLogoSvg from '/src/com/yext/listingslaunchstorm/public/icons/yelp-logo-small.svg';

/** @param {number} publisherId */
export const YelpSyncedFieldsTask = publisherId => new Task({
  id: TaskIds.YELP_SYNCED_FIELDS,

  getCard: (_enterpriseConfiguration, _index, selectedPageId, setSelectedPageId, disabled) => ({
    id: TaskIds.YELP_SYNCED_FIELDS,
    title: yext.msg('Field Sync & Mapping'),
    icon: (<YelpLogoSvg />),
    isSelected: TaskIds.YELP_SYNCED_FIELDS === selectedPageId,
    onClick: disabled ? undefined : () => setSelectedPageId(TaskIds.YELP_SYNCED_FIELDS),
    content: undefined,
  }),

  getPage: (enterpriseConfiguration, setEnterpriseConfiguration, _pageControls) => ({
    id: TaskIds.YELP_SYNCED_FIELDS,
    layoutHeader: {
      icon: (<YelpLogoLargeSvg />),
      title: yext.msg('Yelp'),
      description: yext.msg('Configure the sync settings below to prevent the syncing of certain fields or to change the default mapped field. If no changes are made, all default settings will be applied.'),
    },
    content: (
      <YelpSyncedFields
        publisherId={publisherId}
        yelpConfiguration={enterpriseConfiguration.yelpConfiguration ?? YelpConfiguration.empty()}
        setYelpConfiguration={yelpConfiguration => setEnterpriseConfiguration(
          new EnterpriseConfiguration({...enterpriseConfiguration, yelpConfiguration}),
        )}
      />
    ),
  }),

  isComplete: () => true,
  isSectionSkipped: () => false,
});
